const styles = {
  arrowIcon: {
    width: '10px',
    height: '10px',
    marginLeft: '5px',
  },
};

export default styles;
